import { render, staticRenderFns } from "./AntiSlaveryAndTrafficking.vue?vue&type=template&id=eee58c70&"
import script from "./AntiSlaveryAndTrafficking.vue?vue&type=script&lang=js&"
export * from "./AntiSlaveryAndTrafficking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports